import { sendGTMEvent } from '@next/third-parties/google';
import { hasAnalyticsConsent } from '@/lib/analytics/consent';
import { isMetaAdsSession } from '@/lib/analytics/meta-ads-session';

/** Do not static-import `react-facebook-pixel`: it touches `window` at load time and breaks SSR. */

const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID?.trim();

function gtmConfigured(): boolean {
  return Boolean(process.env.NEXT_PUBLIC_GTM_ID?.trim());
}

/** Push to `dataLayer` when GTM is configured and marketing cookies are accepted. */
export function gtmEvent(data: Record<string, unknown>, dataLayerName?: string): void {
  if (typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;
  if (!gtmConfigured()) return;
  sendGTMEvent(data, dataLayerName);
}

function metaAllowed(): boolean {
  return Boolean(META_PIXEL_ID) && isMetaAdsSession();
}

/** Meta standard events — only when Pixel is configured and this session came from Meta ads. */
export function metaTrack(event: string, data?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;
  if (!metaAllowed()) return;
  void import('react-facebook-pixel').then(({ default: ReactPixel }) => {
    ReactPixel.track(event, data);
  });
}

/** Meta custom events — same gating as {@link metaTrack}. */
export function metaTrackCustom(name: string, data?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;
  if (!metaAllowed()) return;
  void import('react-facebook-pixel').then(({ default: ReactPixel }) => {
    ReactPixel.trackCustom(name, data);
  });
}
